<template>
  <div>
    <span v-if="restriction_data">
      <strong>Restricted Features : </strong><span>{{ getRestrictionsByType('restricted_features') }}</span><br>
      <strong>Restricted Actions : </strong><span>{{ getRestrictionsByType('restricted_actions') }}</span><br>
    </span>
  </div>
</template>

<script>
import PropertiesMixin from "VueMixins/ActivityLog/PropertiesMixin";

export default {
  mixins: [PropertiesMixin],
  props: {
    rowProperties: {
      type: Object,
      required: true,
    },
  },
  computed: {
    restriction_data() {
      if (!this.rowProperties.attributes || !this.rowProperties.attributes.data) {
        return null;
      } else {
        return JSON.parse(this.rowProperties.attributes.data);
      }
    },
  },
  methods: {
    getRestrictionsByType(type) {
      if (!this.restriction_data || !this.restriction_data[type]) {
        return null;
      }

      const restrictions = [];
      _.forEach(this.restriction_data[type], (restriction) => {
        restrictions.push(restriction);
      });

      return restrictions.join(", ");
    },
  },
};
</script>

<style lang="scss" scoped>
  .key {
    text-transform: capitalize;
  }
</style>
